<template>
    <section class="content">
        <template v-for="alert in alerts">
            <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
                <h4>
                    <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
                    <i class="icon fa fa-ban" v-else></i>
                    {{'alert_'+alert.type | translate}}!</h4>
                <p v-if="alert.type !== 'danger'">
                    {{alert.message}}
                </p>
                <ul v-else>
                    <li v-for="e in alert.message">
                        {{e}}
                    </li>
                </ul>
            </b-alert>
        </template>
        <avis-upload @alert="alert" @toggle="loading = !loading"></avis-upload>
    </section>
</template>
<script>
  import AvisUpload from '../tools/AvisFileUpload.vue'
  export default {
    data () {
      return {
        files: [],
        edit: [],
        alerts: [],
        loading: false
      }
    },
    components: {
      AvisUpload
    },
    computed: {
    },
    methods: {
      sendData (method, data = {note: this.noteBody}) {
        let extra = ''
        if (method === 'PUT' || method === 'DELETE') {
          extra = '/' + data.id
          data.title = data.original_title
          data.sub_title = data.original_sub
          this.loading = true
        }
        API({method: method, url: 'files' + extra, data: data})
          .then(response => {
              this.loading = false
              this.alerts.push({dismiss: 4, type: 'success', message: 'Success', icon: 'icon fa fa-check', show: true})
              this.refresh(method === 'PUT' ? data.id : true)
            })
          .catch(error => {
              this.alerts.push({dismiss: 4, type: 'danger', message: [error.response.data.message], icon: 'icon fa fa-check', show: true})
              this.loading = false
            })
      },
      editFile (id) {
        this.edit[id] = true
        this.edit = [...this.edit]
      },
      alert (value) {
        this.alerts.push(value)
        this.refresh()
      },
      refresh (flag) {
        API.get('files')
          .then(response => {
              this.files = response.data
              if (flag) {
                  this.edit[flag] = false
                  this.files.forEach(n => {
                  n.original_title = n.title
                  n.original_sub = n.subtitle
                })
              } else {
                  this.files.forEach(n => {
                  this.edit[n.id] = false
                  n.original_title = n.title
                  n.original_sub = n.subtitle
                })
              }
            })
      }
    },
    mounted () {
      this.$nextTick(function () {
        this.refresh()
      })
    }
  }
</script>

<style>
    .overlay {
        z-index: 50;
        background: rgba(33,34,40,.75);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 110%;
    }
    .overlay > .fa {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: currentColor;
        font-size: 2rem;
        opacity: 0.65;
    }
</style>
<style scoped>
    .loading-gif {
        display: block;
        width: 5%;
        top: 42%;
        left: 50%;
        position: fixed;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/AvisUploader.vue